import React from 'react';
import { Checkbox, CheckboxProps, FormControlLabel } from '@mui/material';

export type PayerCheckboxProps = {
  onChange: (checked: boolean) => void;
  label: string;
} & Omit<CheckboxProps, 'onChange'>;

const PayerCheckbox = ({ label, checked, onChange, ...props }: PayerCheckboxProps) => {
  return (
    <FormControlLabel
      checked={checked ?? false}
      control={
        <Checkbox
          color="primary"
          size="small"
          {...props}
          disabled={props.disabled ?? false}
          onChange={event => onChange(event.target.checked)}
        />
      }
      label={label}
    />
  );
};

export { PayerCheckbox };
